import { graphql, useStaticQuery } from "gatsby";

export const UseDepositCalculatorQuery = (keyword) => {
  const { allStrapiDepositCalculator } = useStaticQuery(graphql`
    query DepositCalculatorQuery {
      allStrapiDepositCalculator {
        nodes {
          keyword
          calculator_head {
            background_color
            title
            title_color
            desclaimer
            desclaimer_color
            calculate_button {
              background_color
              lable
              lable_color
            }
            hero_images {
              hero_image {
                alternativeText
                url
              }
            }
            arrow_icon {
              alternativeText
              url
            }
          }
          calculator_body {
            input_label
            input_label_color
            input_type
            select_options {
              option
              option_color
              value
            }
          }
        }
      }
    }
  `);
  return allStrapiDepositCalculator?.nodes?.find(
    (item) => item.keyword === keyword
  );
};
